export default "__VITE_ASSET__Bnkm5fwi__"